export default __webpack_public_path__ + "static/media/btn_fair.b261a43b.jpg";